<template>
    <div class="land-lobbi">
        <div class="container">
            <div class="land-lobbi-column-container">
                <div class="col-left">
                    <div class="land-section-title">
                        <h2>{{salesCard.project_land_site.lobbi_title}}</h2>
                    </div>
                    <div class="desc-main" v-html="salesCard.project_land_site.lobbi_desc"></div>
                </div>
                <div class="col-right">
                    <div class="lobbi-gallery" :class="{'nav-init' : salesCard.project_land_site.lobbi_gallery != undefined && salesCard.project_land_site.lobbi_gallery.length > 1}">
                        <swiper :options="swiperOption" ref="landLobbiGallery">
                            <swiper-slide v-for="(slide, index) in salesCard.project_land_site.lobbi_gallery" :key="index">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="swiper-controls sales-land-controls sales-land-lobbi-controls" v-if="salesCard.project_land_site.lobbi_gallery != undefined && salesCard.project_land_site.lobbi_gallery.length > 1">
                        <div class="container">
                            <div class="sales-land-btn-prev sales-land-lobbi-btn-prev slider-btn">
                                <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                            </div>
                            <div class="sales-land-btn-next sales-land-lobbi-btn-next slider-btn">
                                <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination sales-land-pagination sales-land-lobbi-pagination" v-if="salesCard.project_land_site.lobbi_gallery != undefined && salesCard.project_land_site.lobbi_gallery.length > 1"></div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-lobbi',
        components: {
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-land-lobbi-btn-next',
                        prevEl: '.sales-land-lobbi-btn-prev',
                    },
                    pagination: {
                        el: '.sales-land-lobbi-second-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-lobbi.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-lobbi-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>